import Vue from 'vue'

export default class HealthParameters {

  static updateHealthParameters = (data, customerId) => {
    data.id = customerId
    if (Object.keys(data).includes('feet')) {
      var height = data.feet * 30.48 + data.inches * 2.54
    }
    data.height = height
    return Vue.http.post(window.API_URL + 'doctors/customer_health_parameters', data)
  }

  static updateGeneralParameters = (data, customerId) => {
    data.id = customerId
    return Vue.http.patch(window.API_URL + 'doctors/customers/' + customerId + '/update_customer_details', data)
  }

}



// WEBPACK FOOTER //
// ./src/api/customer/health_parameters.js